import { Component } from '@angular/core';
import { MySkillVerificationsConstants } from '../../constants/my-skill-verifications.constants';
import { MySkillVerificationsService } from '../../services/my-skill-verifications.service';
import { LabelConstants } from '../../../shared/constants/label-constants';

@Component({
  selector: 'app-my-skill-verifications',
  templateUrl: './my-skill-verifications.component.html',
  styleUrls: ['./my-skill-verifications.component.scss']
})
export class MySkillVerificationsComponent {
topBarTitle:string= MySkillVerificationsConstants.MySkillVerifications_TopBarTitle;
showAllLabel:string= MySkillVerificationsConstants.MySkillVerifications_ShowAllLabel;
isIncludeAll:boolean= MySkillVerificationsConstants.MySkillVerifications_IsIncludeAll;
showInformationIconCheckbox:boolean= MySkillVerificationsConstants.MySkillVerifications_ShowInformationIconCheckbox;
showAllTooltip:string= MySkillVerificationsConstants.MySkillVerifications_CheckBoxHoverToolTip;
panelListType:string= MySkillVerificationsConstants.MySkillVerifications_PanelListType;
showLoader:boolean= true;
isScreenAccessible:boolean= true;
errorMessage!: string;
displayShowAllButton:boolean=true;
displayShowAllLabel:boolean=true;
skillVerifications:any[]=[];

constructor(private mySkillVerificationsService: MySkillVerificationsService) {}
ngOnInit(): void {
  this.getSkillVerificationListDate(this.isIncludeAll);
}

// includeInactive(isIncludeAll: boolean){
//   this.getSkillVerificationListDate(isIncludeAll);
// }

getSkillVerificationListDate(isIncludeAll:boolean){
  this.mySkillVerificationsService.getSkillVerificationListData(isIncludeAll).subscribe({
    error:(err) => {
      if(err.status === LabelConstants.Forbidden_StatusCode) {
        this.errorMessage = err.error.detail;
      } 
      this.isScreenAccessible = false;
      this.showLoader = false;
    },
    next:(serviceDate) =>{
      this.skillVerifications = serviceDate;
      this.showLoader = false;
    }
  })
}
}
